export { default as ListVehicles } from './List'
export { default as CreateVehicle } from './Create'
export { default as ShowVehicle } from './Show'
export { default as EditVehicle } from './Edit'
